import { isComplainable } from '@printdeal/business-logic';

import { SanitizedLineItem } from '../../../../../../types/order/Order';

const canAddComplaintHelper = (lineItem: SanitizedLineItem) => ({
  enabled: isComplainable(lineItem),
});

export default canAddComplaintHelper;
